export default __webpack_public_path__ + "static/media/refresh.d664717b.png";